import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-apps',
	path: '/jira/servicedesk/projects/:projectKey/settings/apps/:appId?',
	exact: true,
};
